import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ANIMATION_TIMING, EASING_CURVES } from "../utils/motion";
import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
import NavBar from "./nav-bar/nav-bar";
import NavBarMobile from "./nav-bar/nav-bar-mobile";
import ScrollToTopButton from "./scroll-to-top";
import { ScrollProvider } from "../utils/ScrollContext";
import CustomFooter from "./CustomFooter";
import CustomFooterMobile from "./CustomFooter-mobile";

const Contact = ({
  textes,
  screenSize,
  setIsBackgroundWhite,
  isBackgroundWhite,
}) => {
  const [hideScroll, setHideScroll] = useState(false);

  // Set background to black when component mounts
  useEffect(() => {
    if (setIsBackgroundWhite) {
      setIsBackgroundWhite(false);

      // Cleanup function to reset when component unmounts
      return () => {
        setIsBackgroundWhite(true);
      };
    }
  }, [setIsBackgroundWhite]);

  // FAQ data array
  const faqData = [
    {
      id: 1,
      question: "1. Qu'est-ce que le motion design ?",
      answer:
        "Le motion design, ou design animé, consiste à animer des éléments graphiques comme du texte, des illustrations ou des logos pour créer des vidéos dynamiques. C'est un excellent levier pour captiver l'attention, transmettre un message ou renforcer une identité de marque.\n👉 Chez Studio Sam, nous vous accompagnons dans la création de contenus en motion design sur-mesure, de la conception à la post-production.",
    },
    {
      id: 2,
      question: "2. Comment faire du motion design ?",
      answer:
        "Le motion design se réalise à l'aide de logiciels spécialisés comme After Effects, Premiere Pro ou Cinema 4D. Il faut à la fois des compétences techniques en animation et un œil graphique pour construire un storytelling visuel.\n👉 Studio Sam met à votre service ses expertises créatives et techniques pour produire des vidéos animées ef caces et adaptées à votre univers de marque.",
    },
    {
      id: 3,
      question: "3. Pourquoi utiliser le motion design en communication ?",
      answer:
        "Le motion design permet de vulgariser un message, de capter l'attention rapidement sur les réseaux sociaux, ou encore de renforcer l'engagement autour d'une campagne. C'est un format agile, moderne et impactant.\n👉 Studio Sam aide les agences et les marques à intégrer le motion dans leurs stratégies de communication digitale ou événementielle.",
    },
    {
      id: 4,
      question: "4. Quel est le prix d'une vidéo en motion design ?",
      answer:
        "Le coût d'une vidéo motion dépend de plusieurs facteurs : durée, complexité, direction artistique, voix off, livrables, etc. Les tarifs peuvent aller de quelques centaines à plusieurs milliers d'euros selon le projet.\n👉 Chez Studio Sam, nous proposons un tarif journalier (TJM) transparent, et des devis clairs, adaptés à chaque besoin.",
    },
    {
      id: 5,
      question: "5. Quels sont les délais pour produire une vidéo animée ?",
      answer:
        "Selon le projet, un motion peut être produit en quelques jours ou en plusieurs semaines. Tout dépend du brief, des allers-retours, et du niveau de complexité (illustration, sound design, etc.).\n👉 Studio Sam est reconnu pour sa réactivité et s'adapte aux deadlines, même les plus serrées, sans sacri er la qualité.",
    },
    {
      id: 6,
      question: "6. Avec quels outils travaillez-vous en motion design ?",
      answer:
        "Nous utilisons principalement Adobe After Effects, Premiere Pro, Photoshop, et Illustrator pour la partie créa. Pour certains projets 3D, nous collaborons avec des partenaires spécialisés.\n👉 Studio Sam combine direction artistique, design graphique et animation pour livrer des contenus complets, clés en main.",
    },
    {
      id: 7,
      question: "7. Qui peut faire appel à un motion designer ?",
      answer:
        "Le motion design est utile pour les entreprises, les startups, les marques, mais aussi les agences de communication ou studios de production. Il peut servir à expliquer un service, teaser un produit, animer un logo, etc.\n👉 Studio Sam travaille en direct avec des clients ou en sous-traitance pour les agences, en marque blanche.",
    },
    {
      id: 8,
      question: "8. Peut-on intégrer une direction artistique dans une vidéo motion ?",
      answer:
        "Oui, et c'est même essentiel pour un rendu cohérent et impactant. Cela passe par le choix des typographies, des couleurs, du rythme, des transitions…\n👉 Chez Studio Sam, on assure la direction artistique complète de vos projets motion, du brief jusqu'au rendu nal.",
    },
    {
      id: 9,
      question: "9. Où trouver un motion designer freelance ?",
      answer:
        "Vous pouvez passer par des plateformes ou votre réseau, mais travailler avec un studio spécialisé vous garantit un accompagnement créatif solide.\n👉 Studio Sam, studio indépendant basé en freelance, est votre partenaire agile pour tous vos projets motion design, montage vidéo ou post-prod.",
    },
    {
      id: 10,
      question: "10. Peut-on travailler à distance avec Studio Sam ?",
      answer:
        "Absolument. Nos projets se gèrent 100 % à distance, avec des points réguliers en visio, des partages de chiers sécurisés et une communication uide.\n👉 Studio Sam collabore avec des clients partout en France (et ailleurs), avec une organisation simple et ef cace.",
    },
  ];

  // State for managing which FAQ items are open
  const [openItems, setOpenItems] = useState({ 1: true });

  // Function to toggle FAQ item open/closed state
  const toggleFAQ = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
   <div className="flex flex-col" >
      {/* Navigation */}
      {screenSize >= 1024 && <NavBar textes={textes} isBackgroundWhite={false} initVisible />}
      {screenSize < 1024 && <NavBarMobile textes={textes} isBackgroundWhite={false} />}

        <motion.div className="grid grid-cols-2 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 items-start justify-center max-w-[1500px] mx-auto mt-44 px-4">
          {/* Contactez nous Section */}
          <motion.div
            className="contact-section flex"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: ANIMATION_TIMING.durations.slow,
              delay: 0.3,
              ease: EASING_CURVES.smooth,
            }}
          >
            <div className="ml-4 lg:ml-20 flex flex-col items-start justify-start gap-6">
              <motion.h2
                className="text-8xl sm:text-6xl md:text-8xl lg:text-9xl text-white"
                style={{ fontFamily: "SAM", color: "#00FFCC" }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  delay: 0.4,
                  ease: EASING_CURVES.smooth,
                }}
              >
                Contactez
              </motion.h2>
              <motion.h2
                className="text-8xl sm:text-6xl md:text-8xl lg:text-9xl text-white text-left"
                style={{ fontFamily: "SAM" }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: -30 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  delay: 0.4,
                  ease: EASING_CURVES.smooth,
                }}
              >
                nous
              </motion.h2>
              <motion.p
                className="text-4xl sm:text-2xl md:text-3xl text-white mb-4 text-left"
                style={{ fontFamily: "Lexend" }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  delay: 0.5,
                  ease: EASING_CURVES.smooth,
                }}
              >
                On s'appelle ?
              </motion.p>

              <motion.button
                className="flex p-2 bg-[#00FFCC] text-black shadow-lg mb-20 font-bold text-3xl sm:text-3xl md:text-4xl py-4 px-8"
                style={{ fontFamily: "Lexend" }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  delay: 0.6,
                  ease: EASING_CURVES.smooth,
                }}
              >
                Prendre rendez-vous
              </motion.button>
            </div>
          </motion.div>

          {/* FAQ Section */}
          <motion.div
            className="faq-section flex"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: ANIMATION_TIMING.durations.slow,
              delay: 0.4,
              ease: EASING_CURVES.smooth,
            }}
          >
            <div className="max-w-4xl mx-auto">
              <motion.h2
                className="text-4xl sm:text-5xl md:text-6xl text-white mb-8 text-center hidden"
                style={{ fontFamily: "SAM", color: "#00FFCC" }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  delay: 0.5,
                  ease: EASING_CURVES.smooth,
                }}
              >
                🎥 FAQ – Tout savoir sur le motion design avec Studio Sam
              </motion.h2>
              <motion.div
                className="space-y-4 lg:space-y-6"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.slow,
                  delay: 0.6,
                  ease: EASING_CURVES.smooth,
                }}
              >
                {faqData.map((faq, index) => (
                  <motion.div
                    key={faq.id}
                    className="overflow-hidden border border-white border-x-0 border-t-0"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: ANIMATION_TIMING.durations.normal,
                      delay: 0.7 + index * 0.1,
                      ease: EASING_CURVES.smooth,
                    }}
                  >
                    {/* FAQ Question */}
                    <motion.button
                      onClick={() => toggleFAQ(faq.id)}
                      className="w-full px-4 lg:px-6 py-4 text-left flex justify-between items-center"
                      aria-expanded={openItems[faq.id]}
                      aria-controls={`faq-answer-${faq.id}`}
                      whileHover={{ scale: 1.01 }}
                    >
                      <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white pr-4">
                        {faq.question}
                      </h3>
                      <motion.div
                        animate={{ rotate: openItems[faq.id] ? 45 : 0 }}
                        transition={{ duration: 0.2 }}
                        className="flex-shrink-0"
                      >
                        <svg
                          className="w-5 h-5 lg:w-6 lg:h-6 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 4v16m8-8H4"
                          />
                        </svg>
                      </motion.div>
                    </motion.button>

                    {/* FAQ Answer */}
                    <motion.div
                      id={`faq-answer-${faq.id}`}
                      initial={false}
                      animate={{
                        height: openItems[faq.id] ? "auto" : 0,
                        opacity: openItems[faq.id] ? 1 : 0,
                      }}
                      transition={{
                        duration: 0.3,
                        ease: EASING_CURVES.smooth,
                      }}
                      className="overflow-hidden"
                    >
                      <div className="px-4 lg:px-6 pb-4 py-5">
                        <p
                          className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed"
                          style={{ fontFamily: "Lexend" }}
                        >
                          {faq.answer.split("\n").map((line, idx) => (
                            <React.Fragment key={idx}>
                              {line}
                              {idx < faq.answer.split("\n").length - 1 && <br />}
                            </React.Fragment>
                          ))}
                        </p>
                      </div>
                    </motion.div>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </motion.div>
        </motion.div>

        {/* Custom Footer */}
        {screenSize < 768 ? (
          <CustomFooterMobile textes={textes} />
        ) : (
          <CustomFooter textes={textes} />
        )}
    </div>

  );
};

export default Contact;
